export default function removeMask(val) {
  if (typeof val !== "string") {
    return val;
  }
  return val.replace(/[^A-Z0-9]/gi, "");
}
